<template>
  <div style="position:relative; padding-bottom:60px" :class="type === 'write' ? '' : 'flex'">
    <el-card :class="type === 'write' ? '' : 'w50'">
      <div slot="header">
        <span>{{ $t('after-sales::in-box::邮件信息') }}</span>
      </div>
      <el-form
        :model="form"
        :label-position="'top'"
        ref="form"
        :rules="rules"
        label-width="80px"
        class="form-wrapper"
        v-loading="loading"
        :class="type === 'write' ? 'flex' : ''"
      >
        <div :class="type === 'write' ? 'w50' : ''">
          <el-form-item :label="$t('after-sales::in-box::sender')" v-if="isWrite" prop="accountId">
            <el-select
              style="width:100%"
              v-model="form.accountId"
              @change="handleChange"
              filterable
              :placeholder="$t('after-sales::in-box::please_select')"
            >
              <!-- :no-data-text="selectSearch.load"
              :filter-method="filterMethod" -->
              <el-option
                v-for="item in sendOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('after-sales::in-box::recipient')" prop="outUser">
            <el-input
              class="send-input-item"
              v-model="form.outUser"
              :placeholder="$t('after-sales::in-box::placeholder_请输入收件人')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('after-sales::in-box::bcc')" v-if="isWrite">
            <el-input
              class="send-input-item"
              v-model="form.bcc"
              :placeholder="$t('after-sales::in-box::placeholder_请输入密送')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('after-sales::in-box::subject')" prop="subject">
            <el-input
              class="send-input-item"
              v-model="form.subject"
              :placeholder="$t('after-sales::in-box::placeholder_请输入主题')"
            >
              <i v-if="!isWrite" slot="prefix">Re:</i>
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('after-sales::in-box::attachment')">
            <z-upload
              :append-to-body="true"
              v-model="form.attachmentList"
              accept="png,jpg,xlsx,xls"
              :limit="5"
              :multiple="true"
            ></z-upload>
          </el-form-item>
        </div>
        <el-form-item :label="$t('after-sales::in-box::content')" :class="type === 'write' ? 'ml24 w50' : ''">
          <RichEditor
            v-model="form.content"
            :height="type === 'write' ? 600 : 350"
            :placeholder="$t('after-sales::in-box::content_placeholder')"
          />
        </el-form-item>
      </el-form>
    </el-card>
    <el-card v-if="type === 'back'" class="w50 order-list">
      <div class="order-item" :key="item.orderNo + i" v-for="(item, i) in orders">
        <div class="order-info">
          <div class="title">{{ $t('after-sales::in-box::订单信息') }}</div>
          <div class="info">
            <p class="name">{{ $t('after-sales::in-box::order_number') }}：</p>
            <div class="content">{{ item.orderNo }}</div>
          </div>
          <div class="info">
            <p class="name">{{ $t('after-sales::in-box::shop_order_number') }}：</p>
            <div class="content">{{ $dataCheck(item.sourceNo) }}</div>
          </div>
          <div class="info">
            <p class="name">{{ $t('after-sales::in-box::logistics_number') }}：</p>
            <div class="content">{{ $dataCheck(item.fulfillmentTrackingNumbersString) }}</div>
          </div>
          <div class="info">
            <p class="name">{{ $t('after-sales::in-box::payment_serial_number') }}：</p>
            <div class="content">{{ $dataCheck(item.paymentNo) }}</div>
          </div>
          <div class="info">
            <p class="name">{{ $t('after-sales::in-box::payment_date') }}：</p>
            <div class="content">{{ $dataCheck(item.payTime) }}</div>
          </div>
          <div class="info">
            <p class="name">{{ $t('after-sales::in-box::country') }}：</p>
            <div class="content">{{ $dataCheck(item.country) }}</div>
          </div>
        </div>
        <div class="order-info">
          <div class="status-title">
            <span>{{ $t('after-sales::in-box::order_status') }}：</span>
            <div class="status">{{ $dataCheck(orderStatus[item.orderStatus]) }}</div>
          </div>
          <div class="info">
            <p class="name">{{ $t('after-sales::in-box::payment_status') }}：</p>
            <div class="content">{{ $dataCheck(payStatus[item.payStatus]) }}</div>
          </div>
          <div class="info">
            <p class="name">{{ $t('after-sales::in-box::logistics_online_status') }}：</p>
            <div class="content">{{ $dataCheck(fulfillmentStatus[item.fulfillmentStatus]) }}</div>
          </div>
          <div class="info">
            <p class="name">{{ $t('after-sales::in-box::after_sale_status') }}：</p>
            <div class="content">{{ $dataCheck(salesStatus[item.salesStatus]) }}</div>
          </div>
        </div>
      </div>
      <ZDefaultData v-show="!orders.length"></ZDefaultData>
    </el-card>
    <footer-fixed>
      <el-button size="small" type="default" class="f-btn" @click="$router.go(-1)">
        {{ $t('after-sales::in-box::btn_cancel') }}
      </el-button>
      <el-button size="small" type="primary" class="f-btn" :loading="sendLoading" @click="onSend">
        {{ $t('after-sales::in-box::btn_send') }}
      </el-button>
    </footer-fixed>
  </div>
</template>

<script>
import ZDefaultData from '@/components/common/default-data/main'
import RichEditor from '@/components/rich-editor'
import { updateEmailSend, getEmailFromOrder, getEmailInfoList, getEmailSign } from '@/server/after-sales.js'
import { getOrderList } from '@/server/order.js'
import { ORDER_STATUS, SALES_STATUS, FULFILMENTSTATUS, PAY_TYPE, PAY_STATUS } from '@/config'
export default {
  components: {
    RichEditor,
    ZDefaultData
  },
  data() {
    return {
      // type: this.$route.query.type || 'write',
      orderStatus: ORDER_STATUS,
      salesStatus: SALES_STATUS,
      payType: PAY_TYPE,
      payStatus: PAY_STATUS,
      fulfillmentStatus: FULFILMENTSTATUS,
      selectSearch: {
        load: '',
        timer: null
      },
      rules: {
        accountId: [{ required: true, message: $t('after-sales::in-box::select_receiver_input'), trigger: 'change' }],
        subject: [{ required: true, message: $t('after-sales::in-box::input_subject_input'), trigger: 'change' }],
        outUser: [
          { required: true, message: $t('after-sales::in-box::input_receiver_input'), trigger: 'change' },
          { type: 'email', message: $t('after-sales::in-box::history_correct_holder') }
        ]
      },
      orders: [],
      sendOptions: [],
      emailList: [],
      show: false,
      orderLoading: false,
      sendLoading: false,
      loading: false,
      form: {
        accountId: '',
        outUser: '',
        bcc: '',
        subject: '',
        content: '',
        inboxId: '',
        attachmentList: []
      }
    }
  },
  computed: {
    type() {
      return this.$route.query.type || 'write'
    },
    isWrite() {
      return this.type === 'write'
    },
    emailInfo() {
      return this.$store.state.email.email
    }
  },
  activated() {
    // this.$route.meta.name = '回信'
    if (this.type === 'write') {
      this.getEmailListInfo()
    } else if (this.type === 'back') {
      this.$nextTick(() => {
        this.form = {
          accountId: this.emailInfo.accountId,
          outUser: this.emailInfo.from,
          bcc: '',
          subject: this.emailInfo.subject,
          content: '',
          inboxId: this.emailInfo.id,
          attachmentList: []
        }
        this.getEmailSignInfo(this.emailInfo.accountId)
        this.getOrderListItem(this.emailInfo.id, this.emailInfo.from)
      })
    }
  },
  methods: {
    async getOrderListItem(id) {
      this.orderLoading = true
      const res = await getEmailFromOrder({ inboxId: id })

      if (res.data.code === this.$code) {
        if (res.data.data && res.data.data.length) {
          this.emailList = res.data.data
          const { data } = await getOrderList({ emails: res.data.data, pageNum: 1, pageSize: 1000 })

          if (data.code === this.$code) {
            this.orders = data.data.items
          }
        }
      }
      this.orderLoading = false
    },
    async getEmailListInfo() {
      this.loading = true
      const { data } = await getEmailInfoList({ pageSize: 10000, pageNum: 1, status: 1 })
      this.loading = false
      if (data.code === 0) {
        this.sendOptions = data.data.items.map(i => ({ label: i.outUser, value: i.id }))
      }
    },
    handleChange(val) {
      this.getEmailSignInfo(val)
    },
    async getEmailSignInfo(accountId) {
      this.contentLoading = true
      const { data } = await getEmailSign({ accountId })

      this.contentLoading = false
      if (data.code === this.$code) {
        let tent = ''
        if (data.data) {
          tent = `<br/><div id="sign-in-content-set">${data.data}</div>`
        }
        const formContent = String(this.form.content)
          .split('\n')
          .join('')
          .replace(/(<div\s+id="sign-in-content-set.+<\/div>)+?/, '')

        this.form.content = formContent + tent
      }
    },
    async onSend() {
      this.$refs['form'].validate(async valid => {
        if (valid) {
          this.sendLoading = true
          const params = {
            ...this.form,
            subject: (this.form.subject = this.isWrite ? this.form.subject : 'Re:' + this.form.subject)
          }
          if (this.isWrite) {
            delete params.inboxId
          }
          const { data } = await updateEmailSend(params)
          this.sendLoading = false
          if (data.code === this.$code) {
            this.keepUpdate('/in-box')
            this.closeCurTab()
            this.$router.push('/in-box')
            this.$message.success(this.$t('system::tip::send_success'))
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-card__header {
  border-bottom: 1px solid #dcdfe6;
}
.ml24 {
  margin-left: 24px;
}
.flex {
  display: flex;
}
.w50 {
  width: 50%;
}
.order-list {
  margin-left: 16px;
  overflow: auto;
  max-height: 992px;
  .order-item {
    .title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 24px;
    }
    .order-info {
      padding: 24px;
    }
    .order-info + .order-info {
      border-top: 1px solid #dcdfe6;
    }
    .info {
      display: flex;
      width: 100%;
      color: #666;
      .name {
        width: 100px;
      }
      .content {
        flex: 1;
        word-break: break-all;
      }
    }
    .info + .info {
      margin-top: 16px;
    }
    .status-title {
      margin-bottom: 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      .status {
        background: #ff8e40;
        border-radius: 2px;
        color: #ffffff;
        padding: 2px 5px;
        font-size: 12px;
      }
    }
  }
  .order-item + .order-item {
    border-top: 10px solid #eeeeee;
  }
  /deep/.el-card__body {
    padding: 0;
  }
}
</style>
